import React from 'react';

export const MobileContext = React.createContext({
  mobile: null
})

export const CurrencyContext = React.createContext({
  currencyID: 0,
  SetCurrencyID: () => { },
});

